import React, { useState } from "react";
import { Box, Grid, Typography, Paper, Button, Popover } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Link } from "react-router-dom";
import editIcon from "./Edit-pen.svg";
import bin from "./bin.svg";
import {
  useGetBookingComponentQuery,
  useGetBookingFacilityQuery,
  useViewBookingDetailsQuery,
} from "../../../../../api/financeApi";
import { FormatDateTime } from "../../../../../../utils/functions/ResourceFunctions";

const BookingsServiceDetails = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const { id } = useParams();
  const { data, isLoading } = useViewBookingDetailsQuery(id);

  const { data: item } = useGetBookingFacilityQuery({
    pageSize: 10000,
    pageNumber: 1,
  });
  const { data: facilityData } = useGetBookingComponentQuery({
    pageSize: 10000,
    pageNumber: 1,
    // FacilityId: facilityName,
  });

  // console.log("facilityData", facilityData?.result?.items);
  // console.log("item", item?.result?.items);
  // console.log("data", data?.result);

  // write a function to get the facility name
  const getFacilityName = (facilityId) => {
    const facility = item?.result?.items.find(
      (facility) => facility.id === facilityId
    );
    return facility?.facilityName;
  };

  const getStatusLabel = (status) => {
    if (status === 0) return "Inactive";
    if (status === 1) return "Active";
    if (status === 2) return "Maintenance";
  };

  const statusColors = {
    Active: "bg-green-100 text-green-700",
    Inactive: "bg-red-100 text-red-700",
    Maintenance: "bg-yellow-100 text-yellow-700",
  };

  const getStatusColor = (status) => {
    const label = getStatusLabel(status);
    return statusColors[label];
  };

  const getComponentName = (componentIds) => {
    console.log("componentIds", componentIds);

    const components = facilityData?.result?.items.filter(
      (component) => componentIds.includes(String(component.id)) // Convert component.id to string
    );

    console.log("components", components);

    return components?.map((component) => component.componentName).join(", ");
  };

  if (isLoading || !data) {
    return <div>Loading...</div>;
  }

  const result = data?.result;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <Box sx={{ padding: 4 }}>
      <div className="mb-5">
        <Button
          startIcon={<ArrowBackIcon />}
          variant="outlined"
          style={{ marginRight: "10px" }}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </div>
      <div className="flex justify-between mb-5">
        <Typography variant="h4">Service Details</Typography>
        {/* <Button onClick={handleClick} variant="contained" color="primary">
          Action <KeyboardArrowDownIcon className="text-[#fff]" />
        </Button> */}
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className="p-3 flex flex-col gap-8 h-[150px] w-[285px]">
          <div className="flex gap-3 items-center">
            <img className="w-[14px] h-[14px]" src={editIcon} alt="edit con" />
            <Link
              to={`/dashboard/finance/update-service/${id}`}
              className="text-[#4B664C] hover:text-[#305F32]"
            >
              Update
            </Link>
          </div>
          <div className="flex gap-3 items-center">
            <img className="w-[14px] h-[14px]" src={bin} alt="delete icon" />
            <button>Delete</button>
          </div>
        </div>
      </Popover>
      {/* Service Information */}
      <Paper
        elevation={1}
        sx={{ padding: 3, marginBottom: 4, backgroundColor: "#F8F9FA" }}
      >
        <Grid container spacing={4}>
          <Grid item xs={12} sm={3}>
            <Typography variant="body1" fontWeight="bold">
              Service Information
            </Typography>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Grid container spacing={2}>
              {/* requisitorName */}
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="textSecondary">
                  Requisitor Name:
                </Typography>
                <Typography variant="body1">
                  {result?.requisitorName}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="textSecondary">
                  Service Name:
                </Typography>
                <Typography variant="body1">
                  {result?.service?.serviceName}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="textSecondary">
                  Date Created:
                </Typography>
                <Typography variant="body1">
                  {FormatDateTime(result?.createdDate)}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="textSecondary">
                  Facility
                </Typography>
                <Typography variant="body1">
                  {getFacilityName(result?.facilityId)}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="textSecondary">
                  Facility Component
                </Typography>
                <Typography variant="body1">
                  {getComponentName(result?.components.split(","))}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="textSecondary">
                  Start Date
                </Typography>
                <Typography variant="body1">
                  {FormatDateTime(result?.startDate)}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="textSecondary">
                  Status:
                </Typography>
                <Typography variant="body1">
                  <span
                    style={{
                      backgroundColor:
                        result?.approvalStatus === 1
                          ? "green"
                          : result?.approvalStatus === 0
                          ? "yellow"
                          : "red",
                      padding: "5px",
                      borderRadius: "5px",
                      color: "white",
                    }}
                  >
                    {getStatusLabel(result?.approvalStatus)}
                  </span>
                  {/* {getStatusLabel(result?.approvalStatus)} */}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      {/* Facilities Information */}
      {/* <Paper elevation={1} sx={{ padding: 3, marginBottom: 4, backgroundColor: "#F8F9FA" }}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={3}>
            <Typography variant="body1" fontWeight="bold">
              Facilities Information
            </Typography>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="textSecondary">
                  Facility Name:
                </Typography>
                <Typography variant="body1">
                  Toyota Hiace 16-Seaters Bus
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="textSecondary">
                  Description:
                </Typography>
                <Typography variant="body1">
                  Ideal for group travel, the Toyota Hiace 16-Seater Bus offers comfortable seating for up to 16 passengers.
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="textSecondary">
                  Quantity:
                </Typography>
                <Typography variant="body1">36</Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="textSecondary">
                  Available Quantity:
                </Typography>
                <Typography variant="body1">4</Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="textSecondary">
                  Status:
                </Typography>
                <Typography variant="body1" color="green">
                  Available
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="textSecondary">
                  Location:
                </Typography>
                <Typography variant="body1">Lagos</Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="body2" color="textSecondary">
                  Booking Price:
                </Typography>
                <Typography variant="body1">34,000</Typography>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <img
                    src="https://via.placeholder.com/100x75"
                    alt="Facility 1"
                    style={{ borderRadius: 4 }}
                  />
                  <img
                    src="https://via.placeholder.com/100x75"
                    alt="Facility 2"
                    style={{ borderRadius: 4 }}
                  />
                  <img
                    src="https://via.placeholder.com/100x75"
                    alt="Facility 3"
                    style={{ borderRadius: 4 }}
                  />
                  <img
                    src="https://via.placeholder.com/100x75"
                    alt="Facility 4"
                    style={{ borderRadius: 4 }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper> */}
    </Box>
  );
};

export default BookingsServiceDetails;
